const errorPageStrings =  {
  generalErrorInfo: "Beklager, noe gikk galt.",
  labels: {
    goBackButton: "Tilbake til forsiden"
  }
};

export default errorPageStrings;